import React from 'react';

import { OrganizationAppShell, Settings } from '~/components/layouts';
import { SystemSettings } from '~/components/pages/Settings_SystemSettings';
import { FirebaseProvider } from '~/components/partials';

const SettingsSystemSettingsPage = () => {
  return (
    <FirebaseProvider>
      <OrganizationAppShell>
        <Settings>
          <SystemSettings />
        </Settings>
      </OrganizationAppShell>
    </FirebaseProvider>
  );
};

export default SettingsSystemSettingsPage;
